function initFormValidation(){
  const form = document.querySelector('[data-validate-form] form');
  if (!form) return;
  const button = form.querySelector('.cb-form-button');
  const textInputs = form.querySelectorAll('input:not([type="checkbox"])');
  const checkboxInput = form.querySelectorAll('input[type="checkbox"]');
  const allTextFilled = Array.from(textInputs).every(input => input.value.trim() !== '');
  const allChecked = Array.from(checkboxInput).every(checkbox => checkbox.checked);
  allTextFilled && allChecked ? button.classList.remove('cb-form-btn-disabled') : button.classList.add('cb-form-btn-disabled');
}
document.querySelectorAll('[data-validate-form] form input').forEach(el => {
  el.addEventListener('input', initFormValidation);
  el.addEventListener('change', initFormValidation);
})
initFormValidation();

function initCloseAnnouncementBar() {
  const barEl = document.querySelector('[data-announcement-bar]');
  if (!barEl) return;
  const btnEl = document.querySelector('[data-close-btn]');
  btnEl.addEventListener('click', e => {
    barEl.remove();
  })
}
initCloseAnnouncementBar();

// Sibling product swatch image swap on collection cards
function initSiblingSwatches() {
  document.querySelectorAll('[data-sibling-card]').forEach(card => {
    const imageDataEl = card.querySelector('.sibling-image-data');
    if (!imageDataEl) return;

    let imageMap;
    try {
      imageMap = JSON.parse(imageDataEl.textContent);
    } catch(e) { return; }

    const cardImg = card.querySelector('.card__media img');
    if (!cardImg) return;

    // Store original image so we can restore on mouse-out
    const originalSrc = cardImg.src;
    const originalSrcset = cardImg.srcset;
    const originalAlt = cardImg.alt;

    const swatches = card.querySelectorAll('.swatch-input__label[title], .swatch-link__label[title]');

    swatches.forEach(swatch => {
      const productUrl = swatch.href || swatch.closest('label')?.previousElementSibling?.dataset?.productUrl;
      // For <a> tags, href is the product URL directly
      const url = swatch.href || swatch.dataset.productUrl;
      if (!url) return;

      // Find matching image data — match by URL path
      const matchKey = Object.keys(imageMap).find(key => url.includes(key) || key.includes(new URL(url, location.href).pathname));
      if (!matchKey) return;

      const imgData = imageMap[matchKey];

      swatch.addEventListener('mouseenter', () => {
        cardImg.src = imgData.src;
        cardImg.srcset = '';
        if (imgData.alt) cardImg.alt = imgData.alt;
      });

      swatch.addEventListener('mouseleave', () => {
        cardImg.src = originalSrc;
        cardImg.srcset = originalSrcset;
        cardImg.alt = originalAlt;
      });

      swatch.addEventListener('click', (e) => {
        // Prevent navigation — update card image and mark as selected
        e.preventDefault();
        cardImg.src = imgData.src;
        cardImg.srcset = '';
        if (imgData.alt) cardImg.alt = imgData.alt;

        // Update card link hrefs to point to the selected sibling
        card.querySelectorAll('a.full-unstyled-link').forEach(link => {
          link.href = swatch.href || matchKey;
        });

        // Update selected state on swatches
        card.querySelectorAll('.swatch-input__label, .swatch-link__label').forEach(s => {
          s.classList.remove('swatch-input__label--selected');
        });
        swatch.classList.add('swatch-input__label--selected');
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initSiblingSwatches);
// Also re-init after any collection filtering/pagination that re-renders cards
document.addEventListener('shopify:section:load', initSiblingSwatches);
